/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, orange } from '../tokens';

// 48x48 orange-outline ghost with a plus glyph. Pass `to` for an internal route
// (SPA navigation) and/or `onClick` for custom behavior.
const AddButton = ({ onClick, to, title = 'Add' }) => {
  const history = useHistory();
  const t = tokens(useTheme());
  const [h, setH] = useState(false);
  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (to) history.push(to);
  };
  return (
    <button
      title={title}
      onClick={handleClick}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      style={{
        width: 48,
        height: 48,
        flexShrink: 0,
        borderRadius: 10,
        cursor: 'pointer',
        background: h ? orange(0.12) : 'transparent',
        border: '1.5px solid ' + (h ? t.primary : orange(0.55)),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 150ms ease',
      }}
    >
      <Icon name="plus" size={22} color={t.primary} />
    </button>
  );
};

export default AddButton;
